export function to_plain_text(value) {
  return String(value || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/\s+/g, " ")
    .trim();
}

export function format_organization_type(value) {
  if (typeof value === "number") return "";

  return String(value || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .trim();
}

export function get_active_organization_id() {
  return localStorage.getItem("active_organization_id")
    || localStorage.getItem("organization_id")
    || null;
}

export function is_active_organization_public() {
  return !!get_active_organization_id()
    && localStorage.getItem("organization_is_private") === "false";
}

export function get_retrieve_users_params() {
  const organization_id = get_active_organization_id();
  return organization_id ? { organization_id } : {};
}

export function append_active_organization_id(payload = {}) {
  const organization_id = get_active_organization_id();
  return organization_id
    ? Object.assign({}, payload, { organization_id })
    : payload;
}

export function append_active_organization_form_data(formData) {
  const organization_id = get_active_organization_id();
  if (organization_id) {
    formData.append("organization_id", organization_id);
  }
  return formData;
}

export function get_current_organization_permissions() {
  return parse_json_or_null(localStorage.getItem("current_organization_permissions")) || [];
}

export function set_current_organization_permissions(permissions = []) {
  localStorage.setItem(
    "current_organization_permissions",
    JSON.stringify(Array.isArray(permissions) ? permissions : [])
  );
}

export function is_enabled_feature(value) {
  return value === true || value === "true" || value === 1 || value === "1";
}

export function is_admin_user_role(user_details = {}) {
  return String(user_details.user_role || "").toLowerCase().includes("admin");
}



export function is_organization_admin_role(user_details) {
  return is_admin_user_role(user_details);
}

export function get_organization_banner_gradient(branding = {}) {
  const primary = branding?.primary_color;
  const secondary = branding?.secondary_color || primary;
  const tertiary = branding?.tertiary_color || secondary;
  if (!primary && !secondary && !tertiary) return "";

  return `linear-gradient(135deg, ${primary || secondary || tertiary} 0%, ${secondary || primary || tertiary} 55%, ${tertiary || secondary || primary} 100%)`;
}

export function parse_json_or_null(value) {
  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

export function first_present(...values) {
  return values.find((value) => value !== undefined && value !== null && String(value).trim() !== "") || "";
}

function unique_values(values) {
  return [...new Set(values.filter((value) => value !== undefined && value !== null && String(value).trim() !== ""))];
}

export function get_organization_branding_storage_keys({
  organization_id,
  profile_id,
  user_id,
} = {}) {
  const stored_organization_id = get_active_organization_id();
  const keys = unique_values([
    organization_id,
    stored_organization_id,
    profile_id,
    user_id,
    "current",
  ]);

  return keys.map((key) => `organization_branding_${key}`);
}

export function get_organization_branding(context = {}) {
  const keys = get_organization_branding_storage_keys(context);

  for (const key of keys) {
    const branding = parse_json_or_null(localStorage.getItem(key));
    if (branding) return branding;
  }

  return null;
}

export function save_organization_branding(branding, context = {}) {
  if (!branding) return;

  const serialized_branding = JSON.stringify(branding);
  get_organization_branding_storage_keys(context).forEach((key) => {
    localStorage.setItem(key, serialized_branding);
  });
}

export function remove_organization_branding(context = {}) {
  get_organization_branding_storage_keys(context).forEach((key) => {
    localStorage.removeItem(key);
  });
}
